var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15V16C6 16.394 6.0776 16.7841 6.22836 17.1481C6.37913 17.512 6.6001 17.8427 6.87868 18.1213C7.15726 18.3999 7.48797 18.6209 7.85195 18.7716C8.21593 18.9224 8.60603 19 9 19C9.39397 19 9.78407 18.9224 10.1481 18.7716C10.512 18.6209 10.8427 18.3999 11.1213 18.1213C11.3999 17.8427 11.6209 17.512 11.7716 17.1481C11.9224 16.7841 12 16.394 12 16V15M15 7C15 9.99999 17 15 17 15H1C1 15 3 11 3 7C3 3.732 5.732 1 9 1C12.268 1 15 3.732 15 7Z",
    stroke: "#2AB7F8",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.198a4f2bfd4812c5ac85b5f55b5e24ec.svg";
export { ForwardRef as ReactComponent };